import React, { useState, useEffect, useLayoutEffect, useRef } from "react"
import { Main } from "./styles"
import { useWatchVariations, mvSubscribe } from "./../context"
import { KILL_ROUTE, UPDATE_ROUTE } from "./../constants"
import WishlistButton from "components/wishlist-button/WishlistButton"

export function Wishlist({ ctx }) {
  const { wactive, route, incard } = useWatchVariations(ctx)
  const [wprops, setWprops] = useState(null)
  const rfmain = useRef(null)

  function onRoute(v) {
    const state = !!incard ? v !== UPDATE_ROUTE : !!v && v !== KILL_ROUTE
    display(state)
  }

  function display(v) {
    rfmain.current?.classList[!!v ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])

  function update(v) {
    if (!v) return
    setWprops({
      rmc: v.uid,
      family: v.familyCode,
      modelName: v.name,
      newmodelselection: v.newmodelselection,
    })
    onRoute(route.get())
  }

  useEffect(() => mvSubscribe("FooterWishlist wactive", wactive, update, !!incard), [])

  return <Main ref={rfmain} className="cfgvar-wishlist">{wprops && <WishlistButton {...wprops} withLabel={!incard} />}</Main>
}

export function NewModel({ ctx }) {
  const { wactive, route, incard } = useWatchVariations(ctx)
  const [wprops, setWprops] = useState(null)
  const rfmain = useRef(null)

  function onRoute(v) {
    const state = !!incard ? v !== UPDATE_ROUTE : !!v && v !== KILL_ROUTE
    display(state)
  }

  function display(v) {
    rfmain.current?.classList[!!v ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])

  function update(v) {
    if (!v) return
    setWprops({
      rmc: v.uid,
      family: v.familyCode,
      modelName: v.name,
      newmodelselection: v.newmodelselection,
    })
    onRoute(route.get())
  }

  useEffect(() => mvSubscribe("FooterWishlist wactive", wactive, update, !!incard), [])

  return <Main ref={rfmain} className="cfgvar-newmodel">{wprops && <WishlistButton {...wprops} withLabel={!incard} />}</Main>
}
